import dashboard from "./dashboard"
import profile from "./profile"
import requests from "./requests"
import portfolio from "./portfolio"
import setgoal from "./setgoal"
import prices from "./prices"
import trade from "./trade"

export default [
    ...dashboard,
    ...profile,
    ...requests,
    ...portfolio,
    ...prices,
    ...setgoal,
    ...trade,
]
